import { Controller } from "@hotwired/stimulus"
import { Modal } from 'flowbite'
import videojs from "video.js"

export default class extends Controller {
  static values = {
    resourceId: String,
    showOnLoad: Boolean
  }

  static targets = ["modal"]

  connect() {
    // Initialize Flowbite modal
    this.modal = new Modal(this.modalTarget, {
      backdrop: 'dynamic',
      backdropClasses: 'bg-gray-900/75 fixed inset-0 z-40',
      closable: true
    })

    // Show modal on load if specified
    if (this.showOnLoadValue) {
      this.showModal()
    }
  }

  showModal() {
    this.modal.show()
  }

  closeModal() {
    // Pause the video before closing
    if (this.hasResourceIdValue) {
      try {
        const player = videojs(this.resourceIdValue)
        if (player) {
          player.pause()
        }
      } catch (e) {
        console.log("Video player not found or already disposed")
      }
    }
    
    this.modal.hide()
    this.dispatch('closeModal')
  }

  disconnect() {
    // Clean up modal when controller disconnects
    if (this.modal) {
      this.modal.hide()
    }
  }
}